export default __webpack_public_path__ + "static/media/accurate-answer.9383b7b8.png";